export default "__VITE_ASSET__v_mip1rU__"